import { render, staticRenderFns } from "./ExaminationData.vue?vue&type=template&id=2209b094&"
import script from "./ExaminationData.vue?vue&type=script&lang=js&"
export * from "./ExaminationData.vue?vue&type=script&lang=js&"
import style0 from "./ExaminationData.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports